export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorTwoDecimalDouble = number => {
  /* eslint-disable no-useless-escape */
  const decimalExp = /^[0-9]*(\.[0-9]{0,2})?$/
  /* eslint-enable no-useless-escape */
  const validDecimal = decimalExp.test(number)
  return validDecimal
}

export const validatorEmialPrefix = prefix => {
  /* eslint-disable no-useless-escape */
  const emailPrefixExp = /^[a-zA-Z0-9-_\.]+$/
  /* eslint-enable no-useless-escape */
  const validPrefix = emailPrefixExp.test(prefix)
  return validPrefix
}

export const validatorNegativeNumber = number => {
  /* eslint-disable no-useless-escape */
  const negativeNumberExp = /[,\-]/
  /* eslint-enable no-useless-escape */
  const validNegativeNumber = negativeNumberExp.test(number)
  return !validNegativeNumber
}

export const validatorNotAlphabetic = value => {
  /* eslint-disable no-useless-escape */
  const alphabeticExp = /^[a-zA-Z]*$/
  /* eslint-enable no-useless-escape */
  const validNotAlphabetic = alphabeticExp.test(value)
  return !validNotAlphabetic
}
